import { endOfWeek, startOfWeek } from "date-fns";
import { useContext, useEffect, useState } from "react";
import useEvents from "../../api/hooks/useEvents";
import { mocEvents } from "../../consts/mocks";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import { Event } from "../../interfaces";
import { getEventsBySpecificDateRange } from "../../utils/getMethods";
import EventCard from "./EventCard";
import "./styles/calendar.css";
import HeaderRow from "./sub-components/HeaderRow";
import LocationRow from "./sub-components/LocationRow";
import Table from "./sub-components/Table";

const Calendar = (props: any) => {
  const { isMobile } = useIsMobile();
  const { model, refresh, setRefresh } = useContext(MainContext);

  const eventsHook = useEvents();

  const [eventsFetched, setEventsFetched] = useState<Event[]>([]);

  const [weekStartDay, setWeekStartDay] = useState<Date>(
    startOfWeek(new Date(), { weekStartsOn: 1 })
  );
  const [weekEndDay, setWeekEndDay] = useState<Date>(
    endOfWeek(new Date(), { weekStartsOn: 1 })
  );
  const [eventsDisplayed, setEventsDisplayed] = useState<Event[]>([]);

  useEffect(() => {
    if (isMobile) {
      setEventsDisplayed(eventsFetched);
    } else {
      const filteredEvents = getEventsBySpecificDateRange(
        eventsFetched,
        weekStartDay,
        weekEndDay
      );
      setEventsDisplayed(filteredEvents);
    }
  }, [eventsFetched, weekStartDay, weekEndDay]);

  useEffect(() => {
    if (model) {
      eventsHook.CTAs.getEventListByModelId(model?.id);
    }
  }, [refresh]);

  useEffect(() => {
    /* console.log(
      eventsHook.RESPONSES.getEventListByModelIdResponse,
      eventsHook.RESULTS.getEventListByModelIdResult
    ); */
    if (eventsHook.RESPONSES.getEventListByModelIdResponse?.ok) {
      const tempEventsFetched =
        eventsHook.RESULTS.getEventListByModelIdResult.data;
      let finalArray: any[] = [];
      tempEventsFetched.forEach((event: Event) => {
        finalArray.push({
          ...event,
          starting_date: new Date(event.starting_date),
          ending_date: new Date(event.ending_date),
        });
      });
      const reorderedList = orderedEventsList(finalArray);
      setEventsFetched(reorderedList);
    } else if (
      eventsHook.RESPONSES.getEventListByModelIdResponse?.ok === false
    ) {
    }
  }, [eventsHook.RESPONSES.getEventListByModelIdResponse]);

  const goNextWeek = () => {
    const nextDateStart = new Date(weekEndDay);
    nextDateStart.setDate(weekEndDay.getDate() + 1);
    nextDateStart.setHours(0);
    nextDateStart.setMinutes(0);
    nextDateStart.setSeconds(0);
    setWeekStartDay(nextDateStart);
    const nextDateEnd = new Date(weekEndDay);
    nextDateEnd.setDate(weekEndDay.getDate() + 7);
    nextDateEnd.setHours(23);
    nextDateEnd.setMinutes(59);
    nextDateEnd.setSeconds(59);
    setWeekEndDay(nextDateEnd);
  };
  const goPreviousWeek = () => {
    const nextDateStart = new Date(weekStartDay);
    nextDateStart.setDate(weekStartDay.getDate() - 7);
    nextDateStart.setHours(0);
    nextDateStart.setMinutes(0);
    nextDateStart.setSeconds(0);
    setWeekStartDay(nextDateStart);
    const nextDateEnd = new Date(weekStartDay);
    nextDateEnd.setDate(weekStartDay.getDate() - 1);
    nextDateEnd.setHours(23);
    nextDateEnd.setMinutes(59);
    nextDateEnd.setSeconds(59);
    setWeekEndDay(nextDateEnd);
  };

  const orderedEventsList = (list: Event[]) => {
    return list.sort((a, b) => {
      return a.starting_date.getTime() - b.starting_date.getTime();
    });
  };

  const renderEventsCards = eventsDisplayed.map((event, key) => {
    return (
      <EventCard
        key={key}
        event={event}
        eventToggler={props.eventToggler}
        setEventSelected={props.setEventSelected}
        setOnEdit={props.setOnEdit}
      />
    );
  });

  return (
    <div
      className="calendar shadow"
      style={{
        width: isMobile ? "calc(345px - (19px * 2))" : "",
        padding: isMobile ? "0 19px 45px" : "",
        height: isMobile ? "fit-content" : "",
      }}
    >
      <div
        className="calendar-header"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <div
          className="calendar-title-box"
          style={{
            width: isMobile ? "100%" : "",
            marginLeft: isMobile ? "9px" : "",
          }}
        >
          <p className="calendar-title">Calendar</p>
          <p className="calendar-description">
            Plan and manage the next events
          </p>
        </div>
        <div
          className="cta-header-right-box"
          style={{
            display: "flex",
            width: isMobile ? "100%" : "",
            marginRight: isMobile ? "0" : "",
            gap: isMobile ? "30px" : "",
          }}
        >
          <button
            className="calendar-cta shadow"
            style={{
              width: isMobile ? "100%" : "",
              marginTop: isMobile ? "15px" : "",
              marginRight: isMobile ? "0" : "",
            }}
            onClick={props.eventToggler.toggle}
          >
            <p className="calendar-cta-text offLightBlue">New Event</p>
          </button>

          {!isMobile && (
            <div
              className="Oval"
              style={{
                backgroundColor: "#6788a1",
                marginRight: "20px",
                cursor: "pointer",
                marginTop: isMobile ? "20px" : "",
              }}
              onClick={props.locationToggler.toggle}
            >
              <img src={`${toIcons}/iconly-light-location.svg`} />
            </div>
          )}
          {!isMobile && (
            <>
              <div className="Oval" style={{}} onClick={goPreviousWeek}>
                <img
                  /* className="offLightBlue" */
                  src={`${toIcons}/small-left.svg`}
                  alt=""
                />
              </div>
              <div className="Oval" style={{}} onClick={goNextWeek}>
                <img
                  /* className="offLightBlue" */
                  src={`${toIcons}/small-right.svg`}
                  alt=""
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div
        className="calendar-content"
        style={{
          marginTop: isMobile ? "27px" : "",
        }}
      >
        <div
          className="calendar-events-list"
          style={{ height: isMobile ? "fit-content" : "" }}
        >
          {renderEventsCards}
        </div>
        {!isMobile && (
          <div className="calendar-container">
            <div style={{ display: "flex" }}>
              <HeaderRow
                weekStart={weekStartDay}
                weekEnd={weekEndDay}
                height={"367px"}
                dayRef_fontSize={"14px"}
                monthRef_fontSize={"13px"}
              />
            </div>
            <LocationRow
              events={mocEvents}
              startDate={weekStartDay}
              endDate={weekEndDay}
              locationToggler={props.locationToggler}
              setLocationSelected={props.setLocationSelected}
              setOnEdit={props.setOnEdit}
            />
            <Table
              events={eventsFetched}
              weekStart={weekStartDay}
              weekEnd={weekEndDay}
              eventToggler={props.eventToggler}
              setEventSelected={props.setEventSelected}
              setOnEdit={props.setOnEdit}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Calendar;
